import _ from 'lodash'

export const ReuseMixin = {
  data() {
    return {
      MIXINTopSearchParams: {}, // 表格搜索字段，当前操作的值
      MIXINTopSearchInitialParams: {}, // 初始表格搜索字段
      MIXINTopSearchParamsStorage: {}, // 表格搜索字段，点击搜索后的值
      MIXINDefaultTopSearchSigns: { xxl: 4, xl: 6, lg: 8, md: 12, sm: 24, xs: 24 }, // 表格搜索Form item => 弹性布局的值
      MIXINTopSearchFormSetting: { labelCol: { span: 6 }, wrapperCol: { span: 17 } }, // 表格搜索Form item => Lable & Value 的栅格比例
      MIXINTableLoading: false, // 表格Loading状态
      MIXINTableColumns: [], // 表格表头
      MIXINTableDataSource: [], // 表格列表数据
      MIXINTablePagination: { current: 1, pageSize: 10, total: 0, showQuickJumper: true, showSizeChanger: true, hideOnSinglePage: true } // 表格分页数据
    }
  },
  computed: {
    MIXINTableSetting() {
      return {
        size: 'middle',
        loading: this.MIXINTableLoading,
        columns: this.MIXINTableColumns,
        dataSource: this.MIXINTableDataSource,
        pagination: this.MIXINTablePagination
      }
    }
  },
  methods: {
    /**
     * 获取表格搜索需要传输的参数，使用点击搜索按钮后的存储的值
     * @return Object<Initial TopSearchParams>
    */
    MIXINGetTopSearchTransferParams() {
      return _.cloneDeep(this.MIXINTopSearchParamsStorage)
    },
    /**
     * 获取用于通讯传输的表格分页字段对象
     * @return Object<Axios Pagination>
    */
    MIXIXGetTableTransferPagination() {
      const { current, pageSize } = this.MIXINTablePagination
      return { page: current, per_page: pageSize }
    },
    /**
     * 获取用于通讯传输表格数据的全部字段对象
     * @return Object<Axios TopSearchParams + Pagination>
    */
    MIXIXGetTableTransferAllParams() {
      return { ...this.MIXINGetTopSearchTransferParams(), ...this.MIXIXGetTableTransferPagination() }
    },
    /**
     * 初始化表格搜索数据字段
     * @param params<{Any}>
    */
    MIXINInitTopSearchParams(params) {
      this.MIXINTopSearchParams = _.cloneDeep(params)
      this.MIXINTopSearchInitialParams = _.cloneDeep(params)
      this.MIXINTopSearchParamsStorage = _.cloneDeep(params)
    },
    /**
     * 赋值表格表头数据，预留未来动态表头可能性
     * 主体组件内，可以使用<slot>与其他APi编写差异化部分
     * @param columns:Array<Antd TableColumn>
    */
    MIXINSetTableColumns(columns) {
      this.MIXINTableColumns = _.cloneDeep(columns)
    },
    /**
     * 清空(初始化)表格搜索表单数据以及缓存数据
     * @param after:Function(清空之后干点什么)
    */
    MIXINClearTopSearchParams(after) {
      this.MIXINTopSearchParams = _.cloneDeep(this.MIXINTopSearchInitialParams)
      this.MIXINTopSearchParamsStorage = _.cloneDeep(this.MIXINTopSearchInitialParams)
      after && after()
    },
    /**
     * 保存选择的表格表单数据，用于通信
     * @param after:Function(保存之后干点什么)
    */
    MIXINSaveTopSearchParamsToStorage(after) {
      this.MIXINTopSearchParamsStorage = _.cloneDeep(this.MIXINTopSearchParams)
      after && after()
    },
    /**
     * 触发修改分页并调用拉去数据方法
     * @param fetch<Promise Fucntion>
     * @param page<Number | String>:Default => 1
     * @param pageSize<Number | String>:Default => 10
    */
    MIXINHandlePageChange(fetch, page, pageSize) {
      this.MIXINTablePagination.current = page || 1
      this.MIXINTablePagination.pageSize = pageSize || this.MIXINTablePagination.pageSize || 10
      fetch && this.MIXINFetchTableDataSource(fetch)
    },
    /**
     * 刷新当前数据表格列表
    */
     MIXINHandleRefreshTable(fetch) {
      fetch && this.MIXINHandlePageChange(fetch, this.MIXINTablePagination.current, this.MIXINTablePagination.pageSize)
    },
    /**
     * 通过传入的Promise拉去数据，并调用数据处理方法
     * @param fetch<Promise Fucntion>
    */
    async MIXINFetchTableDataSource(fetch) {
      this.MIXINTableLoading = true
      this.MIXINAfterFetchTableDataSource(await fetch())
    },
    /**
     * 处理传入的最新表格数据的方法
     * @param data<{List Pagination}>
    */
    MIXINAfterFetchTableDataSource(data) {
      const { list, pagination } = data
      this.MIXINTableDataSource = list
      this.MIXINTablePagination.total = pagination.total
      this.MIXINTableLoading = false
    },
    /**
     * 初始化搜索表格分页三件套
     * @param config<{
     *  beforeInit:Funciton(初始化之前的回调)
     *  tableColumns:Array<Antd TableColumn>(基于Antd规则的表格表头)
     *  topSearchParams<{Any}>(搜索表格字段对象)
     *  afterInit:Funciton(初始化之后的回调)
     * }>
    */
    async MIXINInit(config) {
      const { beforeInit, tableColumns, topSearchParams, afterInit } = config
      beforeInit && await beforeInit()
      tableColumns && this.MIXINSetTableColumns(tableColumns)
      topSearchParams && this.MIXINInitTopSearchParams(topSearchParams)
      afterInit && afterInit()
    }
  }
}
